module.exports = __webpack_public_path__ + "static/img/img1.9d20b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img1.png
// module id = icDF
// module chunks = 1